import { render, staticRenderFns } from "./Historie.vue?vue&type=template&id=632ff79a&"
import script from "./Historie.vue?vue&type=script&lang=ts&"
export * from "./Historie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports